module.exports = __webpack_public_path__ + "media/images/athletes/1539-e808976bd2db1c7c17b74bdfcafd48a6.png";